import { render, staticRenderFns } from "./ChangePersonalDataAgreement.vue?vue&type=template&id=13511f35&scoped=true"
import script from "./ChangePersonalDataAgreement.vue?vue&type=script&lang=js"
export * from "./ChangePersonalDataAgreement.vue?vue&type=script&lang=js"
import style0 from "./ChangePersonalDataAgreement.vue?vue&type=style&index=0&id=13511f35&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13511f35",
  null
  
)

export default component.exports